/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the HistoryItem interface.
 */
export function instanceOfHistoryItem(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    return true;
}
export function HistoryItemFromJSON(json) {
    return HistoryItemFromJSONTyped(json, false);
}
export function HistoryItemFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'inputLength': json['input_length'] == null ? undefined : json['input_length'],
        'outputLength': json['output_length'] == null ? undefined : json['output_length'],
        'timestamp': json['timestamp'],
    };
}
export function HistoryItemToJSON(json) {
    return HistoryItemToJSONTyped(json, false);
}
export function HistoryItemToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'input_length': value['inputLength'],
        'output_length': value['outputLength'],
        'timestamp': value['timestamp'],
    };
}
